const TracksPoweredBy = () => {
  return (
    <a
      target="_blank"
      className="flex flex-col items-end gap-1"
      href="https://cafebazaar.ir/app/holdings.kplus.musiciom"
    >
      <p className="text-[9px]">Tracks Powered By</p>
      <img alt="track-cover" src="/images/musiciom-logo.svg" className="w-[80px]" />
    </a>
  );
};

export default TracksPoweredBy;
